module.exports = __webpack_public_path__ + "img/guanyu_mianfei@2x.ffd4f78e.png";